"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var CreateReactComponentFromStencil_1 = require("../../../utils/CreateReactComponentFromStencil");

var ReactUtils_1 = require("../../../utils/ReactUtils");

var ActionGroupInternal = CreateReactComponentFromStencil_1.createReactComponentFromStencil("lsg-actiongroup");

var ActionGroup = function ActionGroup(_a) {
  var left = _a.left,
      children = _a.children,
      className = _a.className,
      id = _a.id;
  return React.createElement(ActionGroupInternal, {
    "class": className,
    id: id
  }, ReactUtils_1.ReactUtils.map(left, function (child) {
    return React.cloneElement(child, {
      htmlAttrs: __assign(__assign({}, child.htmlAttrs), {
        slot: "left"
      })
    });
  }), children);
};

exports.ActionGroup = ActionGroup;